import AuthContentWrapper from "./components/AuthContentWrapper";
import { C2Text, C3Text, T1Text } from "../../common/components/text/CustomText";
import CustomIcon from "../../common/components/image/CustomIcon";
import { Column, Row, SizedBox } from "../../common/components/CommonBaseComponents";
import { useNavigate, useSearchParams } from "react-router-dom";
import FullWidthButton from "../../common/components/button/FullWidthButton";
import CustomCheckbox from "../../common/components/checkbox/CustomCheckbox";
import { useState } from "react";
import Translate from "../../common/translate/Translate";
import Term from "../../common/enums/Term";
import { Theme } from "../../common/Theme";

function TermsPage() {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    const [selectAllTerms, setSelectAllTerms] = useState(searchParams.get("selectAllTerms") === "true" || false);
    const [selectUseTerms, setSelectUseTerms] = useState(searchParams.get("selectUseTerms") === "true" || false);
    const [selectPITerms, setSelectPITerms] = useState(searchParams.get("selectPITerms") === "true" || false);

    function handleHistoryBack() {
        navigate(-1);
    }

    function handleTermsClick(selectedTerms) {
        if (selectedTerms === "allTerms") {
            setSelectAllTerms(!selectAllTerms);
            setSelectUseTerms(!selectAllTerms);
            setSelectPITerms(!selectAllTerms);
            setSearchParams(
                { selectAllTerms: !selectAllTerms, selectUseTerms: !selectAllTerms, selectPITerms: !selectAllTerms },
                { replace: true }
            );
        } else if (selectedTerms === "useTerms") {
            setSelectUseTerms(!selectUseTerms);
            if (selectPITerms && !selectUseTerms) {
                setSelectAllTerms(true);
                setSearchParams({ selectAllTerms: true, selectUseTerms: true, selectPITerms: true }, { replace: true });
                return;
            } else if (!selectPITerms && selectUseTerms) {
                setSelectAllTerms(false);
                setSearchParams(
                    { selectAllTerms: false, selectUseTerms: false, selectPITerms: false },
                    { replace: true }
                );
                return;
            }
            setSearchParams({ selectUseTerms: !selectUseTerms }, { replace: true });
        } else if (selectedTerms === "piterms") {
            setSelectPITerms(!selectPITerms);
            if (!selectPITerms && selectUseTerms) {
                setSelectAllTerms(true);
                setSearchParams({ selectAllTerms: true, selectUseTerms: true, selectPITerms: true }, { replace: true });
                return;
            } else if (selectPITerms && !selectUseTerms) {
                setSelectAllTerms(false);
                setSearchParams(
                    { selectAllTerms: false, selectUseTerms: false, selectPITerms: false },
                    { replace: true }
                );
                return;
            }
            setSearchParams({ selectPITerms: !selectPITerms }, { replace: true });
        }
    }

    function handleClickDetailPage(type) {
        navigate(`/auth/terms/detail?type=${type}`);
    }

    return (
        <AuthContentWrapper contentPadding={"20px"}>
            <CustomIcon iconName={"undo"} size={"36px"} onClick={handleHistoryBack} cursor={"pointer"} />
            <SizedBox height={"6px"} />
            <Column justifyContent={"center"} padding={"0 40px"}>
                <T1Text letterSpacing={"-0.56px"} fontWeight={"500"}>
                    {Translate("auth.terms.title")}
                </T1Text>
                <SizedBox height={"10px"} />
                <C2Text fontColor={Theme.color.gray500} textAlign={"center"}>
                    {Translate("auth.terms.subtitle")}
                </C2Text>
                <SizedBox height={"44px"} />
            </Column>
            <Column padding={"0 40px"} justifyContent={"flex-start"} alignItem={"flex-start"}>
                <Row
                    cursor={"pointer"}
                    // onClick={() => {
                    //     setSelectAllTerms(!selectAllTerms);
                    //     setSelectUseTerms(!selectAllTerms);
                    //     setSelectPITerms(!selectAllTerms);
                    // }}
                    onClick={() => handleTermsClick("allTerms")}
                    width={"100%"}
                >
                    <CustomCheckbox checked={selectAllTerms} />
                    <SizedBox width={"16px"} />
                    <C2Text fontWeight={"500"} fontColor={Theme.color.zinc850}>
                        {Translate("auth.terms.selectAll")}
                    </C2Text>
                </Row>
                <SizedBox height={"20px"} />
                <Row width={"100%"} justifyContent={"space-between"} cursor={"pointer"}>
                    <Row>
                        <CustomCheckbox checked={selectUseTerms} onClick={() => handleTermsClick("useTerms")} />
                        <SizedBox width={"16px"} />
                        <C2Text
                            fontWeight={"400"}
                            fontColor={Theme.color.gray800}
                            cursor={"pointer"}
                            onClick={() => handleClickDetailPage(Term.TermsOfUse)}
                        >
                            (Required) Terms of Use
                        </C2Text>
                    </Row>
                    <CustomIcon
                        iconName={"chevron_right"}
                        size={"16px"}
                        cursor={"pointer"}
                        onClick={() => handleClickDetailPage(Term.TermsOfUse)}
                    />
                </Row>

                <SizedBox height={"20px"} />
                <Row width={"100%"} justifyContent={"space-between"} cursor={"pointer"}>
                    <Row>
                        <CustomCheckbox checked={selectPITerms} onClick={() => handleTermsClick("piterms")} />
                        <SizedBox width={"16px"} />
                        <Column
                            justifyContent={"flex-start"}
                            alignItem={"flex-start"}
                            cursor={"pointer"}
                            onClick={() => handleClickDetailPage(Term.PrivacyPolicy)}
                        >
                            <C2Text fontWeight={"400"} fontColor={Theme.color.gray800}>
                                {Translate("auth.terms.termsOfPI1")}
                            </C2Text>
                            <C2Text fontWeight={"400"} fontColor={Theme.color.gray800}>
                                {Translate("auth.terms.termsOfPI2")}
                            </C2Text>
                        </Column>
                    </Row>
                    <CustomIcon
                        iconName={"chevron_right"}
                        size={"16px"}
                        cursor={"pointer"}
                        onClick={() => handleClickDetailPage(Term.PrivacyPolicy)}
                    />
                </Row>
                <SizedBox height={"26px"} />
                <Row
                    width={"100%"}
                    justifyContent={"space-between"}
                    cursor={"pointer"}
                    onClick={() => handleClickDetailPage(Term.PrivacyPolicy)}
                >
                    <C2Text fontWeight={"500"} fontColor={Theme.color.zinc850}>
                        {Translate("auth.terms.privacyPolicy")}
                    </C2Text>
                    <CustomIcon iconName={"chevron_right"} size={"16px"} cursor={"pointer"} />
                </Row>
                <SizedBox height={"20vh"} />
                <FullWidthButton
                    onClick={() => navigate("/auth/join")}
                    text={Translate("common.ok")}
                    isActive={selectUseTerms && selectPITerms}
                />
                <SizedBox height={"10px"} />
                <FullWidthButton
                    onClick={() => navigate(-1)}
                    text={Translate("common.cancel")}
                    backgroundColor={Theme.color.white}
                    isActive={true}
                />
                <SizedBox height={"20px"} />
                <Row width={"100%"} justifyContent={"center"} alignItem={"center"}>
                    <C3Text fontColor={Theme.color.gray500}>Copyright © LG Electronics. All Rights Reserved.</C3Text>
                </Row>
                <SizedBox height={"42px"} />
            </Column>
        </AuthContentWrapper>
    );
}

export default TermsPage;
